/* odr-article-links.js
 *
 * Links that open a new tab and say nothing about it.
 *
 * WIDENED 2026-09-08 beyond the article. The About page's three news cards
 * ("Read on Fox 8", "Watch on WKYC", "Read Full Article") are page-builder
 * blocks with the same problem, and any block added later will have it too.
 * The rule is now: a link that opens a new tab, has no warning in its own
 * words and no description of its own, gets pointed at the element the theme
 * already renders for this. Links that already say it, and links the theme
 * itself writes with a description, are left alone.
 *
 * Article body links open a new tab and say nothing about it. The links are
 * written in the blog editor, so the theme cannot add an attribute to them at
 * render time — but it already renders the element the rest of the site points
 * at for exactly this, `#a11y-new-window-message`, reading "Opens in a new
 * window." This points the article's links at the same one.
 *
 * WHY A FILE RATHER THAN AN INLINE SCRIPT. It was inline first, twice: above
 * the container, where it matched nothing because the container had not been
 * parsed yet; then below it, where it was in the DOM and still never ran. An
 * asset loaded with `defer` executes on any page the theme renders, which is
 * the behaviour that was wanted both times.
 *
 * The visible half is the arrow in article.css. This is the half a screen
 * reader hears.
 */
(function () {
  var ID = 'a11y-new-window-message';

  function mark() {
    if (!document.getElementById(ID)) return;
    var links = document.querySelectorAll('a[target="_blank"]:not([aria-describedby])');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      /* Its own words already say so — "(opens in a new tab)", "opens an
         external site". Leave those; a second announcement is worse than none. */
      var text = (a.getAttribute('aria-label') || a.textContent || '').toLowerCase();
      if (/new (tab|window)|opens (a|an)/.test(text)) continue;
      a.setAttribute('aria-describedby', ID);
    }
  }

  mark();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark);
  /* The theme swaps the page container on navigation, which would otherwise
     take the attributes with it. */
  window.addEventListener('pageshow', mark);
  document.addEventListener('shopify:section:load', mark);
})();
